import React, { FC } from "react";
import { ValueType } from "../data";
import "./styles.scss";
import "../styles.scss";
import { Hr } from "../../_Atoms/Hr";

interface LoanToValueCalculatorResults {
    resultType: ValueType;
    shouldAnimate: boolean;
    results: string[];
}

const ValueTypeLabel1 = {
  [ValueType.DEPOSIT_AMOUNT]: "Loan to value:",
  [ValueType.LOAN_AMOUNT]: "Loan to value:",
  [ValueType.LTV_PERCENTAGE]: "Loan amount:",
};

const ValueTypeLabel2 = {
  [ValueType.DEPOSIT_AMOUNT]: "Loan amount:",
  [ValueType.LOAN_AMOUNT]: "Deposit amount:",
  [ValueType.LTV_PERCENTAGE]: "Deposit amount:",
};

export const LoanToValueCalculatorResults: FC<LoanToValueCalculatorResults> = ({
  resultType, results,
}) => {
  const [result1, result2] = results;
  const selectedTypeLabel1 = ValueTypeLabel1[resultType];
  const selectedTypeLabel2 = ValueTypeLabel2[resultType];

  return (
    <div className="ltv-calculator-result">
      <div className="calculator-panel-v2__horizontal-line calculator-panel-v2__result__header">
        <h3>{selectedTypeLabel1}</h3>
        <span>{result1}</span>
      </div>
      <Hr evenSpacing />
      <div className="calculator-panel-v2__horizontal-line calculator-panel-v2__result__header">
        <h3>{selectedTypeLabel2}</h3>
        <span>{result2}</span>
      </div>
      <p className="ltv-calculator-result-description">
        Our LTV calculation is for guidance only and cannot guarantee what you
        will be able to borrow. Talk to a mortgage broker or lender to get a
        more accurate figure.
      </p>
    </div>
  );
};
